import type { Alert } from '@orgsim/shared';
import { useEffect, useRef } from 'react';

type Props = { alert: Alert; keyword: string; onClose: () => void };

export function AlertCard({ alert, keyword, onClose }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    dialog?.showModal();
    return () => dialog?.close();
  }, []);
  return (
    <dialog
      ref={dialogRef}
      className="alarm-dialog"
      aria-labelledby="alarm-title"
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
    >
      <div>
        <div className="flex items-baseline justify-between border-b border-neutral-800 px-4 py-2">
          <h2 id="alarm-title" className="font-medium">
            Alarmierung
          </h2>
          <span className="font-mono text-sm text-neutral-400">{alert.time}</span>
        </div>
        <dl className="space-y-4 px-4 py-5 text-sm">
          <div>
            <dt className="text-xs text-neutral-400">Stichwort</dt>
            <dd className="text-lg font-semibold text-red-400">{keyword}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-400">Einsatzort</dt>
            <dd>{alert.address}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-400">Meldebild</dt>
            <dd className="whitespace-pre-wrap">{alert.message}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-400">Alarmiert</dt>
            <dd>{alert.units}</dd>
          </div>
        </dl>
        <div className="flex justify-end border-t border-neutral-800 px-4 py-2">
          <button type="button" onClick={onClose} className="button primary">
            Zur Lagekarte
          </button>
        </div>
      </div>
    </dialog>
  );
}
